import { ComponentProps, FC, forwardRef, ReactNode } from 'react'
import { CenteredSpinner } from './primitives'
import { StyledInfiniteScroll } from './primitives/StyledInfiniteScroll'

type Props = Omit<ComponentProps<typeof StyledInfiniteScroll>, 'loader'> & {
  loader?: ReactNode
}

export const InfiniteScroll: FC<Props> = forwardRef(({ children, loader, ...rest }, ref) => {
  return (
    <StyledInfiniteScroll loader={loader || <CenteredSpinner />} {...rest} ref={ref}>
      {children}
    </StyledInfiniteScroll>
  )
})

InfiniteScroll.displayName = 'InfiniteScroll'
